define.alias("shared/utils/constants/days", "media/utils/constants/days");